import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState, } from "react";
import ParticipantListItem from "../Participant/ParticipantListItem";
import { leaderboardActions } from "@/common/store/Leaderboard/actions";
import { useLeaderboard } from "@/common/store/Leaderboard/LoaderboardProvider";
import TeamList from "./TeamList";
import PrevButton from "../components/PrevButton";
import NextButton from "../components/NextButton";
const TeamParticipant = forwardRef((props, ref) => {
    const { participant, pageIndex, participantIndex, distanceTarget } = props;
    const { state, dispatch } = useLeaderboard();
    const [isDetailsOpened, setIsDetailsOpened] = useState(false);
    const [userKey, setUserKey] = useState("");
    const [yOffset, setYOffset] = useState(0);
    const updateLeaderboardStart = () => {
        if (!state || !dispatch)
            return;
        const lookupParams = {
            type: "team",
            id: participant.id,
            version: state?.version ?? "",
            cursor: participant.team.prevCursor,
        };
        leaderboardActions.loadMoreTeamParticipantsStart(lookupParams, dispatch);
    };
    const updateLeaderboardEnd = () => {
        if (!state || !dispatch)
            return;
        const lookupParams = {
            type: "team",
            id: participant.id,
            version: state?.version ?? "",
            cursor: participant.team.nextCursor,
        };
        leaderboardActions.loadMoreTeamParticipantsEnd(lookupParams, dispatch);
    };
    const onItemClickHandler = (offset = 0) => {
        setYOffset(offset);
        setIsDetailsOpened((prev) => !prev);
        const team = state?.pages[pageIndex][participantIndex].team;
        if (participant.type === "team" && !team) {
            const lookupParams = {
                type: "team",
                id: participant.id,
                version: state?.version ?? "",
            };
            leaderboardActions.getTeamParticipants(lookupParams, dispatch);
        }
    };
    const scrollToUser = (offset = yOffset) => {
        const elementPosition = document.getElementById(userKey)?.offsetTop;
        if (!elementPosition) {
            return;
        }
        window.scrollTo({
            top: offset + elementPosition + 40,
            behavior: "smooth",
        });
    };
    const renderContent = useCallback(() => {
        if (!isDetailsOpened || !state) {
            return null;
        }
        const team = state.pages[pageIndex][participantIndex].team;
        if (!team || team.pages.length <= 0) {
            return null;
        }
        return (React.createElement("div", { className: "leaderboard-team-container" },
            React.createElement(PrevButton, { cursor: team.prevCursor, onClick: updateLeaderboardStart }),
            React.createElement(TeamList, { team: team, distanceUnit: state.distanceUnit, distanceTarget: distanceTarget }),
            React.createElement(NextButton, { cursor: team.nextCursor, onClick: updateLeaderboardEnd })));
    }, [state, isDetailsOpened]);
    useImperativeHandle(ref, () => ({
        openTeam: (offset) => !isDetailsOpened
            ? onItemClickHandler(offset) // open team (and scroll to user)
            : userKey !== "" // if user is in the team
                ? scrollToUser(offset)
                : () => { },
    }));
    useEffect(() => {
        if (state) {
            let key = null;
            participant.team?.pages.map((page) => page.map((participant) => {
                if (participant.isCurrentUser) {
                    key = `${participant.type}_${participant.id}`;
                }
            }));
            if (key !== null) {
                setUserKey(key);
            }
        }
    }, [state]);
    useEffect(() => {
        if (userKey) {
            scrollToUser();
        }
    }, [userKey]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { 
            //@ts-ignore
            onClick: onItemClickHandler, type: "button", className: "leaderboard-participant-accordion collapsed" },
            React.createElement(ParticipantListItem, { ...props, isDetailsOpened: isDetailsOpened })),
        renderContent()));
});
export default TeamParticipant;
